<div class="row" id="list-input">
  <span *ngIf="this.itemsPrefix?.length > 0" style="width: 55px;display: inline-block;">{{this.itemsPrefix[currentIndex] ? this.itemsPrefix[currentIndex] : ''}}:</span>
  <mat-form-field
  [ngStyle]="{
    'width.px': 150
  }"
          >
      <input
              matInput
              type="number"
              class="form-control"
              [ngStyle]="{
                'max-width.px': 600
              }"
              value="{{items[currentIndex]}}"
              (focusout)="valueChange($event)"
              (keyup.enter)="valueChange($event)"
              #input
              [step]="this.step"
              [disabled]="!this.editable"
            />

          </mat-form-field>

          <button *ngIf="(currentIndex!==0 || items.length > 1) && !this.disabled" mat-raised-button [disabled]="this.disabled" (click)="removeLine(currentIndex)" style="margin-left:2px">remove</button>
          <button *ngIf="(currentIndex===0) && !this.disabled" mat-raised-button (click)="addLine(currentIndex)"  [disabled]="this.disabled"  [ngStyle]=" items.length === 1 ? {'margin-left.px': 75} : {'margin-left.px': 10 }">add</button>
</div>
